<template>

    <div class="container-center">

        <el-card class="box-card">

            <div slot="header" class="clearfix contract-data-top with-icon">
                <img src="data:image/png;base64,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">
                <p><span class="title">{{ detailData.paymentName || '付款申请发起' }}</span></p>
                <p class="status">
                    <span :title="detailData.approveStatus" v-bind:class="['state-shet'+ detailData.approveStatus]">
                        {{ baseStatus[detailData.approveStatus] }}
                        {{ detailData.nodeName && (`（当前审批节点：${detailData.nodeName}）`) }}
                    </span>
                </p>
                <br>所属合同：{{ decodeURIComponent($route.params.name) }} &nbsp;&nbsp;&nbsp;&nbsp; <span v-if="pageType!=0">发起时间：{{ detailData.createDate }}</span>
            </div>


            <!-- 材料列表 -->
            <label v-if="pageType!=0" class="fade-title">付款申请编号：{{ detailData.paymentNo }}</label>

            <div v-if="pageType==0 || detailData.approveStatus==4 || editMode" style="padding-top:20px;">
                <el-form label-width="140px" ref="form" :model="form" :rules="rules" size="mini">
                    <el-row>
                        <el-col :span="18" :offset="3">
                            <!--<el-form-item label="施工单位申请工程量：" prop="builderQuantities">-->
                                <!--<el-input v-model="form.builderQuantities" clearable></el-input>-->
                            <!--</el-form-item>-->
                            <el-form-item label="本次适用付款条件描述：" prop="paymentDesc">
                                <el-input v-model="form.paymentDesc" type="textarea" 
                                placeholder="请输入最多500字的描述"
                                :rows="4" clearable :maxlength="500"></el-input>
                            </el-form-item>
                            <el-form-item label="本月进度描述：" prop="progressDesc">
                                <el-input v-model="form.progressDesc" type="textarea" 
                                placeholder="请输入最多500字的描述"
                                :rows="4" clearable :maxlength="500"></el-input>
                            </el-form-item>
                            <el-form-item label="确认进度/结算金额（含税）：" prop="settlementAmount">
                                <el-input v-model="form.settlementAmount" clearable><template slot="append">元</template></el-input>
                            </el-form-item>
                            <el-form-item label="累计已支付（含税）：" prop="pay">
                                <el-input v-model="form.pay" clearable><template slot="append">元</template></el-input>
                            </el-form-item>
                            <el-form-item label="本次申请金额（含税）：" prop="applyTaxPrice">
                                <el-input v-model="form.applyTaxPrice" clearable><template slot="append">元</template></el-input>
                            </el-form-item>
                            <el-form-item label="施工负责人：" prop="managerName">
                                <el-input v-model="form.managerName"></el-input>
                            </el-form-item>


                            <el-form-item label="银行信息：">
                                 <div>
                                <el-table :data="bankInfo" border strip >
                                    <el-table-column width="55" label="单选">
                                        <template scope="scope">
                                            <el-radio :label="scope.row.id" v-model="choosedBankId" @change.native="changeChoosedBank(scope.$index, scope.row)">&nbsp;</el-radio>
                                        </template>
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="address"
                                        label="银行所在市">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="accountName"
                                        label="银行开户行名">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="relationNo"
                                        label="银行关联行号">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="name"
                                        label="开户行全称">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="bankNo"
                                        label="银行账号">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center" label="认证状态">
                                        <template slot-scope="scope">
                                            {{ scope.row.status == '2' ? '已认证' : '未认证' }}
                                        </template>
                                    </el-table-column>       
                                </el-table>
                                 </div>
                            </el-form-item>

                            <el-form-item label="附件：" prop="" >
                                <el-upload
                                    class="upload-demo"
                                    multiple
                                    ref="upload"
                                    :limit="20"
                                    :action="uploadApi"
                                    :file-list="form.files"
                                    :on-success="handleAdd" :on-error="uploadError"
                                    :before-upload="beforeUpload"
                                    :on-remove="handleRemove"
                                ><el-button size="small" type="primary">上 传</el-button>
                                    <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                        <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <!-- 详情 -->
            <div v-if="pageType != 0 &&  detailData.approveStatus!=4 && !editMode" class="detail-box">
                <!--<el-row>-->
                    <!--<el-col :span="6" class="text-right">施工单位申请工程量：</el-col><el-col :span="18">{{ form.builderQuantities || '无' }}</el-col>-->
                <!--</el-row>-->
                <el-row>
                    <el-col :span="6" class="text-right">本次适用付款条件描述：</el-col><el-col :span="18">{{ form.paymentDesc || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="text-right">本月进度描述：</el-col><el-col :span="18">{{ form.progressDesc || '无' }}</el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="text-right">确认进度/结算金额（含税）：</el-col><el-col :span="18">{{ form.settlementAmount || '无' }} 元</el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="text-right">累计已支付（含税）：</el-col><el-col :span="18">{{ form.pay || '无' }} 元</el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="text-right">本次申请金额（含税）：</el-col><el-col :span="18">{{ form.applyTaxPrice || '无' }} 元</el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="text-right">施工负责人：</el-col><el-col :span="18">{{ form.managerName || '无' }}</el-col>
                </el-row>
                <el-row v-if="detailData.approveStatus == 3 || detailData.approveStatus == 4">
                    <el-col :span="6" class="text-right">甲方核实工程量：</el-col><el-col :span="18">{{ form.checkQuantities || '无' }}</el-col>
                </el-row>
                <el-row v-if="detailData.approveStatus == 3 || detailData.approveStatus == 4">
                    <el-col :span="6" class="text-right">甲方核实金额（含税）：</el-col><el-col :span="18">{{ form.checkTaxPrice || '无' }}</el-col>
                </el-row>

                <el-row>   
                            <el-col :span="6" class="text-right">银行信息：</el-col>
                            <el-col :span="18">
                                 <div>
                                <el-table :data="bankList" border strip >
                                    <el-table-column header-align="center" align="center"
                                        prop="address"
                                        label="银行所在市">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="accountName"
                                        label="银行开户行名">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="relationNo"
                                        label="银行关联行号">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="name"
                                        label="开户行全称">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center"
                                        prop="bankNo"
                                        label="银行账号">
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center" label="认证状态">
                                        <template slot-scope="scope">
                                            {{ scope.row.status == '2' ? '已认证' : '未认证' }}
                                        </template>
                                    </el-table-column>       
                                </el-table>
                                 </div>
                            </el-col>
                </el-row>
                <br/>
                        
                <el-row>
                    <el-col :span="6" class="text-right">附件：</el-col>
                    <el-col :span="18">
                        <div v-if="!form.baseFileList || form.baseFileList && form.baseFileList.length==0" class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in form.baseFileList" :key="li.id"><a :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName }}</a></li>
                        </ul>
                    </el-col>
                </el-row>
            </div>


            <el-row><el-col :span="12" :offset="6">
                <div class="text-center" style="padding:30px 0;">
                    <el-button @click="$router.push($root.navs[1].path)"  type="" size="medium" icon="el-icon-back">返回合同台账</el-button>
                    <!-- <el-button v-if="!editMode && (detailData.approveStatus==0 || detailData.approveStatus==1)" @click="editMode=true"  type="primary" size="medium">修 改</el-button>
                    <el-button v-if="editMode" @click="getDetailData();editMode=false;"  type="primary" size="medium">退出修改</el-button> -->
                    <el-button v-if="pageType==0" @click="submit" :disabled="submitFlag" type="primary" size="medium">提交申请</el-button>
                </div>
            </el-col></el-row>


            <!-- 分隔线 --><div v-if="pageType!=0" class="fade-line"></div>


            <!-- 审批记录 -->
            <div v-if="pageType!=0">
                <label class="fade-title">审批记录</label>

                <el-table :data="detailData.approveList||[]" size="mini" border stripe>
                    <el-table-column align="center" width="50"  type="index" label="序号"></el-table-column>
                    <el-table-column align="center" width="160" label="发起时间" prop="createDate"></el-table-column>
                    <el-table-column align="center" width="160" label="审批结果" prop="approveStatus">
                        <template slot-scope="scope">
                            <span v-bind:class="'state-shet'+scope.row.approveStatus" :title="scope.row.approveStatus">
                                {{ baseStatus[scope.row.approveStatus] }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center"             label="审批意见" prop="approveRemark" ></el-table-column>
                    <el-table-column align="center" width="160" label="审批时间" prop="approveDate" ></el-table-column>
                </el-table>
            </div>
        </el-card>


    </div><!-- container-center -->

</template>

<script type="text/babel">
import banner from '@/assets/imgs/banner_inviteMng.png'
//import ElBadge from 'element-ui/packages/badge/src/main'
import util from '@/util'
//import ElOption from "element-ui/packages/select/src/option";

export default {
//    components: {
//        ElOption,
//        ElBadge},
    name: 'contract-detail',
    data () {
        return {
            supplierId: this.$root.stockId,
            bankInfo: [],
            choosedBankId: '',

            uploadApi: `${util.baseUrl}rest/file/upload`,
            downloadApi: `${util.baseUrl}rest/file/down`,

            baseStatus: ['草稿','待审批','审批中','资料审核完成','审批不通过'],

            // 编辑模式
            editMode: false,

            // 表单验证
            rules: {
                // builderQuantities: [
                //     {required: true, message: '必填'}
                // ],
                paymentDesc: [
                    {required: true, message: '必填'}
                ],
                progressDesc: [
                    {required: true, message: '必填'}
                ],
                settlementAmount: [
                    {required: true, message: '必填'},
                    { pattern: /^[0-9]+(\.[0-9]{0,2})?$/ ,message:'只能输入大于0的最多两位小数', trigger:'blur'}
                ],
                pay: [
                    {required: true, message: '必填'},
                    { pattern: /^[0-9]+(\.[0-9]{0,2})?$/ ,message:'只能输入大于0的最多两位小数', trigger:'blur'}
                ],
                applyTaxPrice: [
                    {required: true, message: '必填'},
                    { pattern: /^[0-9]+(\.[0-9]{0,2})?$/ ,message:'只能输入大于0的最多两位小数', trigger:'blur'}
                ],
                managerName: [
                    {required: true, message: '必填'}
                ]

            },

            // 页面类型 0: 发起,带billId;  1: 查看,带msgId
            pageType: this.$route.params.type,


            // 详情数据
            detailData: {
                dhsConPricingDetailList: []
            },

            // 表单
            form: {
                // builderQuantities: '',
                paymentDesc: '',
                progressDesc: '',
                settlementAmount: '',
                pay: '',
                applyTaxPrice: '',
                managerId: '',
                managerName: '',
                baseFileList: [],
                bankId:'',
                bankList:[],
            },
            submitFlag: false,
            bankList:[],
        }
    },
    methods: {

        // 上传文件格式验证
        beforeUpload(file){

            if(file.size/1024/1024 > 100) {
                this.$alert('上传附件大小请不要超过100M','文件过大！',{ type: 'error' })
                return false
            }

            if(!util.allowUpload(file.name)){
                this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`,'文件类型不支持，已取消上传！',{ type: 'error' })
                return false
            }
            return true
        },

        uploadError(){
            this.$message({message:'上传出错，请稍后再试。',type:'error'});
        },

        // 获取施工负责人信息
        getBaseProjectTeamInfo () {
            this.$http.post('rest/api/contract/getBaseProjectTeamInfo',{
                msgId: this.$route.params.id
            }).then((res)=>{
                if(res.data.result) {
                    if(res.data.value) {
                        this.form.managerName = res.data.value.userMessageName
                        this.form.managerId = res.data.value.userMessageId
                    } else {
                        // this.$message({message: 'Error: 未获取到施工负责人信息', type: 'error'})
                    }
                } else {
                    this.$message({message: 'Error: 获取施工负责人信息异常', type: 'error'})
                }
            })
        },

        // 提交
        submit () {
            this.submitFlag = true
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if (!this.choosedBankId) {
                        this.submitFlag = false
                        this.$message.error('请选择银行信息');
                        return 
                    }
                    const loading = this.$loading({background:'rgba(255,255,255,0.5)'});

                    this.form.bankId = this.choosedBankId
                    this.form.baseFileList = __getBaseFiles__(null,this.$refs.upload.uploadFiles)

                    if(this.pageType == 0) {  // 发起
                        this.$http.post('rest/api/contract/createPayMent',
                            Object.assign(
                                {
                                    contractBillId: this.$route.params.id
                                },
                                this.form
                            )
                        ).then((res)=>{

                            if(res.data.result) {
                                this.$message({message: '提交成功', type: 'success'})

                                // 提交后跳转
                                this.$router.push('/ContractDetail02/1/'+ res.data.value.id +'/'+ encodeURIComponent(this.$route.params.name))
                                setTimeout(function() {
                                    location.reload()
                                },1000)

                            } else {
                                this.$message({message: 'Error: ' + res.data.message, type: 'error'})
                                this.submitFlag = false
                                loading.close()
                            }
                        }).catch(e => {
                            this.submitFlag = false
                            loading.close()
                        })
                    } else {  // 不通过二次提交
                        // this.$http.post('rest/api/contract/updatePayMent',
                        //     Object.assign(
                        //         {
                        //             id: this.$route.params.id,
                        //             contractBillId: this.detailData.contractBillId
                        //         },
                        //         this.form
                        //     )
                        // ).then((res)=>{

                        //     loading.close()

                        //     if(res.data.result) {
                        //         this.$message({message: '修改成功', type: 'success'})

                        //         this.getDetailData()
                        //         this.editMode = false
                        //     } else {
                        //         this.$message({message: 'Error: ' + res.data.message, type: 'error'})
                        //     }
                        // })
                    }

                } else {
                    this.submitFlag = false
                    this.$message({message: '材料表单填写有误', type: 'error'})
                    return false;
                }

            });

        },
        changeChoosedBank(index, val) {
            this.choosedBankId = val.id
        },
        getBankInfoList () {
                this.$http.post('rest/api/completeFourInfo/getBankInfo', {
                    
                    stockId: this.supplierId
                }).then((res) => {
                    if (res.data.result) {
                        this.bankInfo = res.data.value
                        
                        // 如果第一个是已认证的直接选择
                        if (this.bankInfo.length > 0 && this.bankInfo[0].status == '2') {
                            this.choosedBankId = this.bankInfo[0].id
                        }
                    }
                })
            },
       
        // 获取详情
        getDetailData () {
            const loading = this.$loading({ background:'rgba(255,255,255,0.5)'});
            this.$http.post('rest/api/contract/getPaymentInfo',{
                msgId: this.$route.params.id
            }).then((res)=>{
                loading.close();
                if(res.data.result) {
                    this.detailData = res.data.value;
                    this.form = res.data.value;
                    this.bankList =this.form.bankList;

                    this.form.baseFileList.forEach(function(data){
                        data.name = data.fileOldName
                    })

                    this.$root.navs = [{name:'合同业务列表',path:'/contractList'},{name: decodeURIComponent(this.$route.params.name), path:'/contractSheet/'+ encodeURIComponent(this.detailData.contractBillId) },{name:'详情'}]

                } else {
                    this.$message({message: 'Error: 获取详情', type: 'error'})
                }
            })
        },

        handleRemove: function(file, fileList) {
            // this.form.baseFileList = this.form.baseFileList.filter(function(f){
            //     return f.uid !== file.uid
            // });
        },
        handleAdd: function(response, file, fileList){
            // if(file.status=='success'){
                // this.form.baseFileList = __getBaseFiles__(file,fileList)
            // }
            // if(file.status == 'success' && file.response){
            //     this.form.baseFileList = __getBaseFiles__(file,fileList)
            // }

            // console.log(this.form.files,fileList,'form')
            // this.form.baseFileList.push(file);
        },
    },
    created(){
        this.$root.headImage.src = banner
        this.$root.activeIndex = 'home'
        this.$root.isPublic = false
        this.$root.navs = []
    },
    mounted () {

        // dev test
        window.ji = this;

        // 0: 发起 带billId;  1: 查看 带msgId
        if(this.pageType == 0) {
            this.getBaseProjectTeamInfo()
            this.$root.navs = [{name:'合同业务列表',path:'/contractList'},{name: decodeURIComponent(this.$route.params.name), path:'/contractSheet/'+ encodeURIComponent(this.$route.params.id) },{name:'发起'}]
        } else {
            this.getDetailData()
        }

        util.toTop();

        this.getBankInfoList()

    }
}

function __getBaseFiles__(file,fileList){
    let fs = [];
    fileList.forEach(function (item) {
        console.log('单个上传附件'  + item)
        if(item.response){
            let f = item.response.basefiles[0];
            item.bizTableName =  f.biztablename;
            item.bizTablePkName =  f.biztablepkname;
            item.bizTablePkValue =  f.biztablepkvalue;
            item.fid =  f.fid;
            item.fileCatagoryId = f.filecatagoryid;
            item.fileDesc = f.filedesc;
            item.fileOldName = f.fileoldname;
            item.name = f.fileoldname;
            item.fileName = f.filename;
            item.filePath = f.filepath;
            item.fileSize = f.filesize;
            item.fileType = f.filetype;
            item.sort = f.sort;
        }
        fs.push(item);
    });
    console.log(fs);
    return fs
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';


a {color:var(--cMain);cursor:pointer;}
ul {padding: 0;margin:0;}
ul li {list-style:none;}

.box-card {margin:30px 0;}


.fade-title {display:inline-block;margin-bottom:20px;color:var(--cTxt2);font-size:15px;font-weight:bold;line-height:28px;}
.fade-line {border-top:1px dashed #ddd;margin:40px 0;}


.detail-box {padding:20px 120px;}
.detail-box .el-row {line-height:48px;}
.detail-box .text-right {color:var(--cTxt3);}


</style>



// WEBPACK FOOTER //
// src/pages/dsp/contract/vDetail02.vue